const analyticsMiddleware = () => next => action => {
  window.dataLayer = window.dataLayer || []
  if (action.type === 'SAVE_SEARCH') {
    window.dataLayer.push({
      event: action.type,
      payload: action.payload
    })
  }
  return next(action)
}

export default analyticsMiddleware
